import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "no-data-info d-flex justify-content-center align-items-center" }
const _hoisted_2 = { class: "ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.loaded)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentSeleted), { key: 0 }))
    : (!_ctx.information)
      ? _renderSlot(_ctx.$slots, "noData", { key: 1 }, () => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.showNoDataIcon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(_ctx.noDataIcon)
                }, null, 2))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.noDataText), 1)
          ])
        ], true)
      : _renderSlot(_ctx.$slots, "default", { key: 2 }, undefined, true)
}